import type { Component } from './types';

import { EyeClose, EyeOpen } from '@sgcmpteltd/uikit-react';

import { cn } from '@/lib/utils';

export const InputPasswordIcon: Component = ({ onClick, show }) => {
  const Component = show ? EyeClose : EyeOpen;

  return (
    <div onClick={onClick} onKeyDown={e => e.preventDefault()} role="button" tabIndex={-1}>
      <Component className={cn('text-[#BBBBBB]')} size={18} />
    </div>
  );
};
